import React from 'react';

import GlobalStyles from 'component/layout/globalStyles';

const GlobalStylesLayout = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <>
    <GlobalStyles />
    {children}
  </>
);

export default GlobalStylesLayout;
